import { Button, Form, Col, Offcanvas, Row, Card } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import HelperService from "../../utility/HelperService";
import WebService from "../../utility/WebService";
import { Label } from "../../components/Label/Label";
import Select from "react-select";
import PlotDatePicker from "../../components/PlotDatePicker/PlotDatePicker";
import UploadFile from "../../components/UploadFile/UploadFile";
import { IoClose } from "react-icons/io5";
import DocIcon from "../../assets/images/doc-icon.svg";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
    projectList?: any[];
    vendorList?: any[];
}

interface formInterface {
    id: number
    uuid?: string
    project_id: number
    vendor_id: number
    stock_id: number
    unit_id: number
    quantity: number
    royalty_date: Date | null
    file_name?: string
    created_by?: number
    created_at?: Date
    updated_at?: Date

    // Associations
    vendor?: any;
    unit?: any;
    stock?: any;
}

const AddRoyalty = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, reset, setValue, register } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [stockList, setStockList] = useState<any[]>([]);
    const [isLoadingStock, setIsLoadingStock] = useState<boolean>(false);
    const [projectList, setProjectList] = useState<any[]>([]);
    const [isLoadingProject, setIsLoadingProject] = useState<boolean>(false);
    const [vendorList, setVendorList] = useState<any[]>([]);
    const [isLoadingVendor, setIsLoadingVendor] = useState<boolean>(false);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                console.log("props.data", props.data);
                setValue("id", props.data.id);
                setValue("uuid", props.data.uuid);
                setValue("project_id", props.data.project_id);
                setValue("vendor_id", props.data.vendor_id);
                setValue("stock_id", props.data.stock_id);
                setValue("unit_id", props.data.unit_id);
                setValue("quantity", props.data.quantity);
                setValue("unit", props.data.unit?.name);
                setValue("royalty_date", props.data.royalty_date ? new Date(props.data.royalty_date) : null);
                setValue("file_name", props.data.file_name);
                //  reset(props.data);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
            !stockList.length && getStockList();
        }
    }, [props.isShow, props.data]);

    useEffect(() => {
        props.projectList && setProjectList(props.projectList);
        props.vendorList && setVendorList(props.vendorList);
    }, [props.projectList, props.vendorList]);

    const getStockList = () => {
        setIsLoadingStock(true);
        WebService.getAPI({ action: "stock/list" })
            .then((res: any) => {
                setStockList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.name } } }));
                setIsLoadingStock(false);
            }).catch((e: any) => { setIsLoadingStock(false); })
    };

    const handleFormSubmit = (data: formInterface) => {
        if (!data.file_name) {
            toast.error("Please upload booking form");
            return;
        }
        const url = isEdit ? `royalty/update` : "royalty/create";
        WebService[isEdit ? "putAPI" : 'postAPI']({
            action: url, body: data, id: "changePassword-btn"
        }).then((res: any) => {
            toast.success(res.message);
            closeModal(true);
        }).catch(() => { });
    };

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        reset({});
    };

    const onUploadFile = (data: any, name: string, size: string) => {
        uploadFile(data);
    };

    const uploadFile = (data: any) => {
        WebService.fileUploadAPI({ action: `upload/file`, key: "image", file: data, body: { type: "EXPENSES" }, id: "changePassword-btn" })
            .then(async (res: any) => {
                toast.success("File uploaded successfully");
                setValue("file_name", res.file_name);
            })
            .catch(async (error: any) => { });
    };

    const getSignedUrl = (fileName: string) => {
        WebService.postAPI({ action: "get/signed-url", body: { key: `expenses/${fileName}` } })
            .then((res: any) => {
                if (res && res.signed_url) {
                    window.open(res.signed_url, "_blank");
                } else {
                    toast.error("Failed to get signed URL");
                }
            })
            .catch((error: any) => { toast.error("Failed to get signed URL"); });
    };

    const onDeleteImage = () => {
        setValue("file_name", "");
    };

    return (
        <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
            <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Royalty" : "Add Royalty"}</Offcanvas.Title></Offcanvas.Header>
            <Offcanvas.Body className="form-style">
                <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                    <Row>
                        <Col lg={12} md={6} sm={12} className="mb-3">
                            <Controller
                                control={control}
                                name="project_id"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Project</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                isLoading={isLoadingProject}
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={projectList}
                                                onChange={(e: any) => { onChange(e.value); }}
                                                value={projectList?.find((option: any) => option.value === watchAllFields.project_id)}
                                                placeholder="Select Project"
                                            />
                                        </div>
                                        {errors.project_id && (<div className="login-error mb-3"> <Label title={"Please select project"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            <Controller
                                control={control}
                                name="vendor_id"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Vendor</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                isLoading={isLoadingVendor}
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={vendorList}
                                                onChange={(e: any) => { onChange(e.value); }}
                                                value={vendorList?.find((option: any) => option.value === watchAllFields.vendor_id)}
                                                placeholder="Select Vendor"
                                            />
                                        </div>
                                        {errors.vendor_id && (<div className="login-error mb-3"> <Label title={"Please select vendor"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            <Controller
                                control={control}
                                name="stock_id"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Stock</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                isLoading={isLoadingStock}
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={stockList}
                                                onChange={(e: any) => { onChange(e.value); setValue('unit_id', e.unit_id); setValue('unit', e.unit.name) }}
                                                value={stockList?.find((option: any) => option.value === watchAllFields.stock_id)}
                                                placeholder="Select Stock"
                                            />
                                        </div>
                                        {errors.stock_id && (<div className="login-error mb-3"> <Label title={"Please select stock"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            <div className="d-flex">
                                <Form.Group className="mb-3 w-100">
                                    <Form.Label>Quantity</Form.Label>{" "}
                                    <span className="text-danger">*</span>
                                    <div className="input-group mb-1">
                                        <input type="text" className="form-control ps-3 p-2" placeholder={"Quantity"} {...register("quantity", { required: true })} onKeyPress={HelperService.allowOnlyNumericValue} value={watchAllFields.quantity} />
                                    </div>
                                    {errors.quantity && (<div className="login-error mb-3"> <Label title={"Please enter quantity"} modeError={true} /> </div>)}
                                </Form.Group>
                                <div className="align-self-end ms-2 mb-3">{watchAllFields.unit}</div>
                            </div>

                            <Controller
                                control={control}
                                name="royalty_date"
                                rules={{ required: true, }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Royalty Date</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <div className="col-12 form-group">
                                                <PlotDatePicker
                                                    selected={watch("royalty_date") ? new Date(watch("royalty_date") as any) : null}
                                                    onChange={(date: any) => onChange(date)}
                                                    placeholderText="Select Date"
                                                />
                                                {errors.royalty_date && (<Label title={"Please Select Inventory Date."} modeError={true} />)}
                                            </div>
                                        </div>
                                    </Form.Group>
                                )}
                            />

                            {!watchAllFields.file_name && <UploadFile
                                key={new Date().getTime()}
                                onChange={(data: any, name: string, size: string) => { onUploadFile(data, name, size); }}
                                acceptFileType={["jpg", "jpeg", "pdf", "png"]}
                                message="Upload or Drag and Drop Booking Form here"
                                acceptedSize={5}
                            />}

                            {(watchAllFields.file_name) &&
                                <Card className={`border p-2 d-inline-block px-3 mb-3 me-2 h-auto`}>
                                    <div className="d-flex gap-3 align-items-center">
                                        <div className="me-1">
                                            <IoClose size={20} onClick={() => { onDeleteImage(); }} className="text-secondary opacity-50 hover-effect cursor-pointer close" />
                                        </div>
                                        <div> <img src={DocIcon} width={40} height={40} alt="" /> </div>
                                        <div>
                                            <p className="font-medium font-16 mb-0 cursor-pointer" onClick={() => getSignedUrl(watchAllFields.file_name || "")}>
                                                {watchAllFields.file_name}
                                            </p>
                                        </div>
                                    </div>
                                </Card>}
                        </Col>

                    </Row>
                    <div className="text-center border-top">
                        <Button variant="dark" className="btn-brand-1 px-5 mt-3 mb-3 me-2" type="submit" id="changePassword-btn">{isEdit ? "Update" : "Add"}</Button>
                        <Button variant="light" className="btn-brand-1 px-5 mt-3 mb-3" type="button" onClick={() => closeModal(false)}>Close</Button>
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas >
    );
};

export default AddRoyalty;
